import React from 'react';
import { connect } from 'react-redux';

import classes from './MealsPaxSelectMobile.scss';
import Checkbox from '../../../UI/CommonCheckBox/CommonCheckBox';
import HeadingH3 from '../../../UI/Headings/HeadingH3/HeadingH3';

import * as farePriceActions from '../../../../store/actions/index';

const mealsPaxSelect = (props) => {
    return (
        <div className={classes.Wrapper}>
            <div className={`u-flex justify-content-between align-items-center pt-4 pb-4 pl-6 pr-6`}>
                <HeadingH3 size={16} weight="Medium" color="Dark">Select Passengers</HeadingH3>
                <span onClick={props.onClosePax} className={`u-textColorPrimary u-fontSize13 u-fontWeightMedium`}>DONE</span>
            </div>
            <ul className={classes.List}>
            {   props.passengers.map(passenger => {
                    return <li className={`${classes.ListItem} u-flex justify-content-between align-items-center u-transitionAll300Ease u-cursorPointer pt-3 pb-3 pl-4 pr-4`} key={passenger.paxID} onClick={
                        passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc === "" ? 
                        () => {
                            props.onSelectMeal(passenger.paxID, props.flow, passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc === props.selectedMeals[props.flow][props.flow === 'O' ? props.mealsViewO : props.mealsViewR].desc)
                            props.onAddAddon({addonLabel: "Meals", amount: parseInt(props.amount, 10), legIndex: props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, leg: props.flow === 'O' ? 'O' : 'R'})
                        } : () => {
                            props.onRemoveAddon("Meals", parseInt(passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].amt, 10), props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, props.flow === 'O' ? 'O' : 'R');
                            props.onDeselctMeal(passenger.paxID, props.flow);
                        }
                    }>
                    <div className={`u-flex justify-content-center f-column`}>
                        <p className={`u-fontSize13 u-textColorDark`}>{passenger.travellerDetails.firstName + ' ' + passenger.travellerDetails.lastName}</p>
                        <p>
                            <span className={`u-fontSize13 u-textColorLight`}>{passenger.ssrDetails.ssrMealDetails.length !== 0 ? props.flow === 'O' ? passenger.ssrDetails.ssrMealDetails[0][props.mealsViewOIndex].desc : passenger.ssrDetails.ssrMealDetails[1][props.mealsViewRIndex].desc : null}</span>
                            <span style={{display: (passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc !== "" && (passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc !== props.selectedMeals[props.flow][props.flow === 'O' ? props.mealsViewO : props.mealsViewR].desc))  ? 'inline-block' : 'none'}}>
                                {
                                    passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc !== props.selectedMeals[props.flow][props.flow === 'O' ? props.mealsViewO : props.mealsViewR].desc ? 
                                    <React.Fragment>
                                        <span className="u-textColorDark">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                        <span onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            props.onRemoveAddon("Meals", parseInt(passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].amt, 10), props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, props.flow === 'O' ? 'O' : 'R');
                                            props.onSelectMeal(passenger.paxID, props.flow);
                                            props.onAddAddon({addonLabel: "Meals", amount: parseInt(props.amount, 10), legIndex: props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex, leg: props.flow === 'O' ? 'O' : 'R'})}} className={`u-cursorPointer u-textColorPrimary u-fontSize13`}>Update</span>
                                    </React.Fragment> : null
                                }
                            </span>
                        </p>
                    </div>
                    <Checkbox type="ssr" readOnly checked={(passenger.ssrDetails.ssrMealDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.mealsViewOIndex : props.mealsViewRIndex].desc !== "") ? true : false} />                </li> })}
            </ul>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        passengers: state.farePrice.passengers,
        mealsViewO: state.farePrice.mealsViewOneWay,
        mealsViewR: state.farePrice.mealsViewReturn,
        mealsViewOIndex: state.farePrice.mealsViewOneWayVal,
        mealsViewRIndex: state.farePrice.mealsViewReturnVal,
        selectedMeals: state.farePrice.selectedMeals
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSelectMeal: (id, flow, isUpdate) => dispatch(farePriceActions.selectMeal(id, flow, isUpdate)),
        onDeselctMeal: (id, flow) => dispatch(farePriceActions.deselectMeal(id, flow)),
        onAddAddon: (addon) => dispatch(farePriceActions.addAddon(addon)),
        onRemoveAddon: (label, amount, legIndex, leg) => dispatch(farePriceActions.removeAddon(label, amount, legIndex, leg)),
        onClosePax: () => dispatch(farePriceActions.closePax())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(mealsPaxSelect);


// WEBPACK FOOTER //
// ./src/components/Addons/Meals/MealsPaxSelectMobile/MealsPaxSelectMobile.js